/*
 * StagesService used for getting information about stages.
 */

import { Injectable } from '@angular/core';
import { BaseService } from '@services/base/base.service';
import { HttpService } from '@services/http/http.service';
import { Stage } from '@models/stage';
import { Observable, of } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { AppRoutes } from 'src/app/app.routes';

@Injectable({
  providedIn: 'root'
})
export class StagesService {
  public currentTrail: string;
  public stages: Stage[];
  public stage: Stage;

  // declaration of fields
  constructor(
    public baseService: BaseService,
    public httpService: HttpService
  ) {}

  /*
   * Fetch stages from the API and parse data
   */
  public get(trailId: string): Observable<Stage[]> {
    if (trailId === this.currentTrail) {
      return of(this.stages);
    } else {
      this.currentTrail = trailId;
      return this.httpService.get(`/trails/${trailId}/stages`).pipe(
        map((response: any) => {
          this.stages = response.data;
          return response.data;
        }),
        publishReplay(1),
        refCount()
      );
    }
  }

  /*
   * Get stage by id from the API
   */
  public getById(trailId: string, stagesId: string): Observable<Stage> {
    if (
      this.stage &&
      (this.stage._id === stagesId || this.stage.slug === stagesId)
    ) {
      return of(this.stage);
    } else {
      return this.httpService.get(`/trails/${trailId}/stages/${stagesId}`).pipe(
        map((response: any) => {
          this.stage = response.data;
          return response.data;
        })
      );
    }
  }

  /*
   * Used to check if the provider is visible on the plattform
   */
  public checkStageStatus(stage: Stage): void {
    if (!stage || Object.keys(stage).length === 0) {
      this.baseService.router.navigate([AppRoutes.NotfoundPage]);
    }
  }
}
